import { render } from "./BotSettings.vue?vue&type=template&id=522051de&scoped=true"
import script from "./BotSettings.vue?vue&type=script&lang=js"
export * from "./BotSettings.vue?vue&type=script&lang=js"

import "./BotSettings.vue?vue&type=style&index=0&id=522051de&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522051de"]])

export default __exports__